import { Icon } from '@gitbook/spine-icons';
import type { SidebarButtonProps } from '@gitbook/spine-react';
import { SidebarButton } from '@gitbook/spine-react';

import { SEARCH_OPEN } from '../../Keyboard/shortcuts';
import { useSearchQuery } from '../../navigation';

export interface SearchButtonProps extends Omit<
    SidebarButtonProps,
    'label' | 'icon' | 'iconOnly' | 'onPress'
> {
    ai: boolean;
}

export function SearchButton(props: SearchButtonProps) {
    const { ai, ...rest } = props;
    const [, { open }] = useSearchQuery();
    return (
        <SidebarButton
            iconOnly
            icon={ai ? Icon.SearchOrAsk : Icon.Search}
            label={ai ? 'Ask or search' : 'Search content'}
            onPress={() => open()}
            key={SEARCH_OPEN}
            {...rest}
        />
    );
}
